import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../../../shared/pagination-model';

@JsonObject('PublicationRuleFilters')
export class PublicationRuleFilters extends Pagination {
  @JsonProperty('storeString', String, true) storeString: string = undefined;
  @JsonProperty('storeId', Number, true) storeId: number = undefined;
  @JsonProperty('accountConnectionName', String, true) accountConnectionName: string = undefined;
}
